import { render, staticRenderFns } from "./AppButtons.vue?vue&type=template&id=12f3c710&scoped=true&"
import script from "./AppButtons.vue?vue&type=script&lang=js&"
export * from "./AppButtons.vue?vue&type=script&lang=js&"
import style0 from "./AppButtons.vue?vue&type=style&index=0&id=12f3c710&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../usr/lib/app/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12f3c710",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/usr/lib/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('12f3c710')) {
      api.createRecord('12f3c710', component.options)
    } else {
      api.reload('12f3c710', component.options)
    }
    module.hot.accept("./AppButtons.vue?vue&type=template&id=12f3c710&scoped=true&", function () {
      api.rerender('12f3c710', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "shared/site/patterns/vue/components/AppButtons.vue"
export default component.exports